<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'수령 정보 입력'"
      :modal="true"
      :width="'500px'"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="w100">
      <ul class="filter_list">
        <li>
          <dd class="w100">
            <label class="w30">
              수령인
              <span class="forg">*</span>
            </label>
            <ul class="w70">
              <li>
                <input
                      class="k-textbox w100"
                      :class="{'error' : errorTarget === 'userNm'}"
                      style="float: right"
                      placeholder="대리 수령인 이름을 입력하세요."
                      maxlength="20"
                      v-model = "senderData.userNm"
                      @keyup.enter = "onClickSave"
                >
              </li>
            </ul>
          </dd>
        </li>
        <li>
          <dd class="w100">
            <label class="w30">
              수령인부서
              <span class="forg">*</span>
            </label>
              <ul class="w70">
                <li>
                    <input
                      class="k-textbox w100"
                      :class="{'error' : errorTarget === 'receiveDept'}"
                      style="float: right"
                      placeholder="대리 수령인 부서를 입력하세요."
                      v-model = "senderData.receiveDept"
                      @input="senderData.receiveDept=EtnersCommonUtil.cutByteLength(senderData.receiveDept, 500)"
                      @keyup.enter = "onClickSave"
                    >
                </li>
            </ul>
          </dd>
        </li>
      </ul>
    </div>
    <div class="button_area w40 mgt20">
      <ul>
        <li class="w40">
          <button class="large_btn orange" @click="onClickSave">등록</button>
        </li>
        <li class="w40">
          <button class="large_btn" @click="onClickCancel">취소</button>
        </li>
      </ul>
    </div>
  </kendo-window>
</template>

<script>
import EtnersCommonUtil from '@/common/etners.common.util'

export default {
  name: "CreateSteadReceive",
  methods: {
    validation(){
      const vm = this
      // 필수값 체크
      if (EtnersCommonUtil.isEmpty(vm.senderData.userNm)) {
        kendo.alert('대리 수령인 이름을 입력하세요')
        vm.errorTarget = 'userNm'
        return
      }
      if (EtnersCommonUtil.isEmpty(vm.senderData.receiveDept)) {
        kendo.alert('대리 수령인 부서를 입력하세요')
        vm.errorTarget = 'receiveDept'
        return
      }
      vm.errorTarget = null
      return true
    },
    async onClickSave(){
      const vm = this
      if (vm.validation()) {
        vm.steadRecieve()
      }
    },
    steadRecieve() {
      const vm = this
      const refs = this.$refs
      const data = {
        receiveNm: vm.senderData.userNm,
        receiveDept: vm.senderData.receiveDept
      }
      refs.kendoWindowRef.kendoWidget().close()
      vm.$emit('getUserData', data)
    },
    onClickCancel() {
      const refs = this.$refs
      refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data() {
    return {
      EtnersCommonUtil: EtnersCommonUtil,
      receiveId: this.$route.params.receiveId,
      userDataSource: [],
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      senderData: {
        userNm: null,
        receiveDept: null,
      },
      errorTarget : null,
    }
  }
}
</script>

<style scoped>

</style>
